export default __webpack_public_path__ + "8799866c9579ae5e716b4226a57e525c.svg";